export default __webpack_public_path__ + "static/media/instructionForPriorityAreasOfFocus.20f11c8d.png";